import { useState, useEffect } from 'react';
import { sortCardsBySuit } from '../utils/cardHelpers';

/**
 * Custom hook to load and manage tarot cards
 * Centralizes card loading logic and prevents duplicate API calls
 */
export function useCards() {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadCards = async () => {
      try {
        const apiUrl = '/api/cards';
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          throw new Error(`API returned ${response.status}`);
        }
        
        const data = await response.json();
        
        if (isMounted) {
          const sortedCards = sortCardsBySuit(data);
          setCards(sortedCards);
          setError(null);
        }
      } catch (err) {
        console.error('Error loading cards:', err);
        if (isMounted) {
          setError(err.message);
          // Provide minimal fallback for testing
          setCards([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadCards();

    // Cleanup function to prevent memory leaks
    return () => {
      isMounted = false;
    };
  }, []); // Empty deps - only load once on mount

  return { cards, loading, error };
}
